import { useState, useEffect, useContext } from "react";
import styles from "./styles.module.css";
import { WorkflowsDisbatch } from "../../../contexts/workflows";
import { TypesValue } from "../../../contexts/types";
import { makeid } from "../../../utils/pageactions";
import {
  MdCheckBoxOutlineBlank,
  MdCheckBox,
  MdDelete,
  MdArrowDownward,
  MdArrowUpward,
} from "react-icons/md";
import { HiOutlineArrowNarrowDown } from "react-icons/hi";
import Modal from "../../../modal";
export default function ParamEditor({ workflow, handleDelete }) {
  const [name, setName] = useState("");
  const [params, setParams] = useState([]);
  const [toggle, setToggle] = useState(true);
  const [wfdelete, setWfDelete] = useState(false);
  const disbatch = useContext(WorkflowsDisbatch);

  useEffect(() => {
    setName(workflow.name);
    setParams(workflow.params);
  }, [workflow]);

  const handleNameChange = () => {
    const wf = { ...workflow };
    wf.name = name;
    disbatch({ type: "update", workflow: wf });
  };

  const handleSave = (params) => {
    const wf = { ...workflow };
    wf.params = params;
    disbatch({ type: "update", workflow: wf });
  };

  const onDelete = (value) => {
    const _params = [...params];
    const index = params.findIndex((x) => x.id === value.id);
    _params.splice(index, 1);
    setParams(_params);
    handleSave(_params);
  };

  const handleUpdate = (value) => {
    const _params = [...params];
    const index = params.findIndex((x) => x.id === value.id);
    _params[index] = value;
    setParams(_params);
    handleSave(_params);
  };

  const handleAdd = () => {
    const _params = [...params];
    _params.push({
      name: "",
      type: "Text",
      list: false,
      id: makeid(16),
    });
    setParams(_params);
    handleSave(_params);
  };
  return (
    <>
      <div
        onMouseDown={(e) => e.stopPropagation()}
        className={styles.paramEditor}
      >
        <div style={{ display: "flex", padding: 16 }}>
          <input
            className={styles.nameInput}
            value={name}
            onChange={(e) => setName(e.target.value)}
            onBlur={handleNameChange}
            disabled={!workflow.custom}
          />
          <MdArrowDownward
            className={
              toggle
                ? styles.toggleArrow + " " + styles.open
                : styles.toggleArrow
            }
            onClick={() => setToggle(!toggle)}
          />
        </div>
        <div
          className={
            toggle
              ? styles.paramContainer + " " + styles.open
              : styles.paramContainer
          }
        >
          {params.length > 0 && (
            <div className={styles.paramsTitle}>Params</div>
          )}

          {params.map((p, index) => {
            return (
              <Param
                key={p.id}
                value={p}
                onChange={handleUpdate}
                onDelete={() => onDelete(p)}
                disabled={!workflow.custom}
              />
            );
          })}

          {workflow.custom && (
            <button onClick={handleAdd} className={styles.addParam}>
              Add Param
            </button>
          )}
          <div
            style={{
              borderTop: "1px solid #E0E0E0",
              marginTop: 20,
              padding: 15,
            }}
          >
            <button
              onClick={() => setWfDelete(true)}
              className={styles.deleteButton}
            >
              Delete Workflow
            </button>
          </div>
        </div>
      </div>

      <WfDelete
        onDelete={handleDelete}
        open={wfdelete}
        onClose={() => setWfDelete(false)}
      />
    </>
  );
}

const Param = ({ value, disabled, onChange, onDelete }) => {
  const [name, setName] = useState(value.name);
  const types = useContext(TypesValue);

  const changeName = () => {
    const newValue = { ...value };
    newValue.name = name;
    onChange(newValue);
  };

  const changeType = (v) => {
    const newValue = { ...value };
    newValue.type = v;
    onChange(newValue);
  };

  const changeList = () => {
    const newValue = { ...value };
    newValue.list = !value.list;
    onChange(newValue);
  };
  return (
    <div className={styles.paramItem}>
      <div>
        <div className={styles.paramName}>Param Name</div>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className={"input"}
          onBlur={changeName}
          disabled={disabled}
        />
      </div>
      <div style={{ display: "flex", marginTop: 8 }}>
        <div style={{ flexGrow: 1, marginRight: 12 }}>
          <div className={styles.paramName}>Param Type</div>
          <select
            value={value.type}
            onChange={(e) => changeType(e.target.value)}
            className={"dropdown"}
            disabled={disabled}
          >
            {types.map((t) => {
              return (
                <option key={t.name} value={t.name}>
                  {t.displayName}
                </option>
              );
            })}
          </select>
        </div>
        <div style={{ minWidth: 48 }}>
          <div className={styles.paramName}>List?</div>
          {value.list ? (
            <MdCheckBox
              onClick={changeList}
              disabled={disabled}
              className={styles.checkbox}
            />
          ) : (
            <MdCheckBoxOutlineBlank
              onClick={changeList}
              disabled={disabled}
              className={styles.checkbox}
            />
          )}
        </div>
      </div>
      <div onClick={onDelete} className={styles.paramDelete}>
        Delete
      </div>
    </div>
  );
};

const WfDelete = ({ open, onClose, onDelete }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <div
        style={{
          width: 300,
          padding: 15,
          borderRadius: 8,
          backgroundColor: "white",
          fontFamily: "var(--font)",
        }}
      >
        <div style={{ fontSize: 18 }} className={styles.paramsTitle}>
          Are you sure you want to delete this workflow?
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 20,
          }}
        >
          <button
            style={{
              border: 0,
              borderRadius: 8,
              padding: 8,
              width: 120,
              fontWeight: "600",
              cursor: "pointer",
            }}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            style={{
              border: 0,
              borderRadius: 8,
              padding: 8,
              width: 120,
              fontWeight: "600",
              backgroundColor: "var(--danger)",
              color: "white",
              cursor: "pointer",
            }}
            onClick={() => {
              onDelete();
              onClose();
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
};
